import { apiClient } from "../../../api/client";
import {
  AtualizarFlagsInput,
  Cadastros,
  CriarNpInput,
  CriarNpResult,
  DownloadNpResult,
  NotaPromissoria,
  StatusFiltro,
} from "../types";

const ENDPOINT = "/gestorNotaPromissoria";

/**
 * `apiClient.post` já desembrulha o `data` do corpo da resposta (ver
 * transformResponse em api/client.ts): para um `{ data: X }` vindo do backend,
 * `response.data` é o próprio X. Por isso o parâmetro de tipo aqui é o conteúdo
 * final, e não o envelope — e os hooks leem `response.data`, sem `.data.data`.
 */
export const notaPromissoriaService = {
  listar: (status: StatusFiltro, ids?: number[]) =>
    apiClient.post<NotaPromissoria[]>(ENDPOINT, {
      acao: "listar",
      status,
      ...(ids?.length ? { ids } : {}),
    }),

  cadastros: () => apiClient.post<Cadastros>(ENDPOINT, { acao: "cadastros" }),

  criar: (input: CriarNpInput) =>
    apiClient.post<CriarNpResult>(ENDPOINT, { acao: "criar", ...input }),

  atualizarFlags: (input: AtualizarFlagsInput) =>
    apiClient.post<NotaPromissoria>(ENDPOINT, { acao: "atualizar_flags", ...input }),

  baixar: (ids: number[]) =>
    apiClient.post<{ message: string }>(ENDPOINT, { acao: "baixar", ids }),

  /** Refaz os documentos de compra de NPs já criadas (retry da imagem R). */
  regerarCompra: (ids: number[]) =>
    apiClient.post<{ message: string }>(ENDPOINT, { acao: "regerar_compra", ids }),

  /** ZIP da compra: termo de cessão, NP e CNAB de remessa. */
  download: (ids: number[]) =>
    apiClient.post<DownloadNpResult>(ENDPOINT, { acao: "download", ids }),

  /** Só o CNAB de baixa — .TXT direto para uma NP, ZIP para várias. */
  downloadBaixa: (ids: number[]) =>
    apiClient.post<DownloadNpResult>(ENDPOINT, { acao: "download_baixa", ids }),
};
